import React from 'react'

const CalculatorIcon = () => {
  return (
    <svg viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.066 21.9792H6.934C6.68002 21.9792 6.42853 21.9292 6.19389 21.832C5.95925 21.7348 5.74604 21.5924 5.56646 21.4128C5.20376 21.0501 5 20.5582 5 20.0452V5.91422C5 4.84622 5.866 3.98022 6.934 3.98022H17.065C18.134 3.98022 19 4.84622 19 5.91422V20.0442C19.0001 20.2983 18.9502 20.5499 18.8531 20.7846C18.7559 21.0194 18.6135 21.2327 18.4339 21.4124C18.2543 21.5921 18.0411 21.7347 17.8063 21.8319C17.5716 21.9292 17.3201 21.9792 17.066 21.9792V21.9792Z"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 8.97925H5"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00215 15.9282C8.01541 15.9282 8.02813 15.9335 8.0375 15.9429C8.04688 15.9522 8.05215 15.965 8.05215 15.9782C8.05215 15.9915 8.04688 16.0042 8.0375 16.0136C8.02813 16.023 8.01541 16.0282 8.00215 16.0282C7.98889 16.0282 7.97617 16.023 7.96679 16.0136C7.95742 16.0042 7.95215 15.9915 7.95215 15.9782C7.95215 15.965 7.95742 15.9522 7.96679 15.9429C7.97617 15.9335 7.98889 15.9282 8.00215 15.9282"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00215 18.9304C8.01541 18.9304 8.02813 18.9356 8.0375 18.945C8.04688 18.9544 8.05215 18.9671 8.05215 18.9804C8.05215 18.9936 8.04688 19.0063 8.0375 19.0157C8.02813 19.0251 8.01541 19.0304 8.00215 19.0304C7.98889 19.0304 7.97617 19.0251 7.96679 19.0157C7.95742 19.0063 7.95215 18.9936 7.95215 18.9804C7.95215 18.9671 7.95742 18.9544 7.96679 18.945C7.97617 18.9356 7.98889 18.9304 8.00215 18.9304"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0009 15.9302C12.0075 15.9302 12.014 15.9315 12.0201 15.9341C12.0261 15.9366 12.0317 15.9402 12.0363 15.9449C12.0409 15.9495 12.0446 15.955 12.0471 15.9611C12.0496 15.9672 12.0509 15.9737 12.0509 15.9802C12.0509 15.9935 12.0457 16.0062 12.0363 16.0156C12.0269 16.025 12.0142 16.0302 12.0009 16.0302C11.9877 16.0302 11.975 16.025 11.9656 16.0156C11.9562 16.0062 11.9509 15.9935 11.9509 15.9802C11.9508 15.9736 11.952 15.9671 11.9545 15.961C11.9569 15.9548 11.9606 15.9493 11.9653 15.9446C11.9699 15.9399 11.9755 15.9362 11.9816 15.9338C11.9878 15.9313 11.9943 15.9301 12.0009 15.9302"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0021 15.9282C16.0154 15.9282 16.0281 15.9335 16.0375 15.9429C16.0469 15.9522 16.0521 15.965 16.0521 15.9782C16.0521 15.9915 16.0469 16.0042 16.0375 16.0136C16.0281 16.023 16.0154 16.0282 16.0021 16.0282C15.9889 16.0282 15.9762 16.023 15.9668 16.0136C15.9574 16.0042 15.9521 15.9915 15.9521 15.9782C15.9521 15.965 15.9574 15.9522 15.9668 15.9429C15.9762 15.9335 15.9889 15.9282 16.0021 15.9282"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.0019 12.9282C8.01516 12.9282 8.02788 12.9335 8.03726 12.9429C8.04664 12.9522 8.0519 12.965 8.0519 12.9782C8.0519 12.9915 8.04664 13.0042 8.03726 13.0136C8.02788 13.023 8.01516 13.0282 8.0019 13.0282C7.98864 13.0282 7.97593 13.023 7.96655 13.0136C7.95717 13.0042 7.9519 12.9915 7.9519 12.9782C7.9519 12.965 7.95717 12.9522 7.96655 12.9429C7.97593 12.9335 7.98864 12.9282 8.0019 12.9282"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0009 12.9302C12.0142 12.9302 12.0269 12.9355 12.0363 12.9449C12.0457 12.9543 12.0509 12.967 12.0509 12.9802C12.0509 12.9935 12.0457 13.0062 12.0363 13.0156C12.0269 13.025 12.0142 13.0302 12.0009 13.0302C11.9877 13.0302 11.975 13.025 11.9656 13.0156C11.9562 13.0062 11.9509 12.9935 11.9509 12.9802C11.9508 12.9736 11.952 12.9671 11.9545 12.961C11.9569 12.9548 11.9606 12.9493 11.9653 12.9446C11.9699 12.9399 11.9755 12.9362 11.9816 12.9338C11.9878 12.9313 11.9943 12.9301 12.0009 12.9302"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0019 12.9282C16.0152 12.9282 16.0279 12.9335 16.0373 12.9429C16.0466 12.9522 16.0519 12.965 16.0519 12.9782C16.0519 12.9915 16.0466 13.0042 16.0373 13.0136C16.0279 13.023 16.0152 13.0282 16.0019 13.0282C15.9886 13.0282 15.9759 13.023 15.9665 13.0136C15.9572 13.0042 15.9519 12.9915 15.9519 12.9782C15.9519 12.965 15.9572 12.9522 15.9665 12.9429C15.9759 12.9335 15.9886 12.9282 16.0019 12.9282"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0009 18.9302C12.0075 18.9302 12.014 18.9315 12.0201 18.9341C12.0261 18.9366 12.0317 18.9402 12.0363 18.9449C12.0409 18.9495 12.0446 18.955 12.0471 18.9611C12.0496 18.9672 12.0509 18.9737 12.0509 18.9802C12.0509 18.9935 12.0457 19.0062 12.0363 19.0156C12.0269 19.025 12.0142 19.0302 12.0009 19.0302C11.9877 19.0302 11.975 19.025 11.9656 19.0156C11.9562 19.0062 11.9509 18.9935 11.9509 18.9802C11.9508 18.9736 11.952 18.9671 11.9545 18.961C11.9569 18.9548 11.9606 18.9493 11.9653 18.9446C11.9699 18.9399 11.9755 18.9362 11.9816 18.9338C11.9878 18.9313 11.9943 18.9301 12.0009 18.9302"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0021 18.9302C16.0154 18.9302 16.0281 18.9355 16.0375 18.9449C16.0469 18.9543 16.0521 18.967 16.0521 18.9802C16.0521 18.9935 16.0469 19.0062 16.0375 19.0156C16.0281 19.025 16.0154 19.0302 16.0021 19.0302C15.9889 19.0302 15.9762 19.025 15.9668 19.0156C15.9574 19.0062 15.9521 18.9935 15.9521 18.9802C15.9521 18.967 15.9574 18.9543 15.9668 18.9449C15.9762 18.9355 15.9889 18.9302 16.0021 18.9302"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { CalculatorIcon }
